import { queryOptions } from "@tanstack/react-query";

import type { EventLogSummary } from "@/types/event-log";

import { requestData } from "@/api/api-config";

async function getEventLogs(
  eventId: string,
): Promise<EventLogSummary[] | null> {
  return await requestData<EventLogSummary[]>(
    `check-in/calendar/${eventId}/logs`,
    "get",
  );
}

export const eventLogQueryOptions = {
  list: (eventId: string) =>
    queryOptions({
      queryKey: ["event-logs", eventId],
      queryFn: () => getEventLogs(eventId),
      enabled: !!eventId,
    }),
};
